import { ThemeOptions, createTheme } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { shapes } from './style/shapes';
import { colors } from './style/colors';
import { DROPDOWN_BORDER_COLOR, DROPDOWN_CHEVRON_COLOR } from './style/form';

export const theme: ThemeOptions = createTheme({
  typography: {
    // Same stack as style/fonts.ts. Without the fallback, MUI text (switch labels, inputs)
    // rendered in the browser's default SERIF font, because the IntelOne font is not loaded.
    fontFamily: '"IntelOne Text", sans-serif',
  },
  palette: {},
  shape: {
    borderRadius: shapes.borderRadius,
  },
  // Every MUI select gets the shared dropdown look (style/form.ts) unless it opts out.
  components: {
    MuiSelect: {
      defaultProps: {
        IconComponent: KeyboardArrowDownIcon,
      },
      styleOverrides: {
        icon: {
          color: DROPDOWN_CHEVRON_COLOR,
          '&.Mui-disabled': { color: colors.darkGrey },
        },
      },
    },
    // The global form sheet (style/form.ts) styles every `input`/`textarea`
    // ELEMENT, including the ones MUI renders inside its own fields. A focused
    // MUI TextField therefore drew TWO borders: its own outline, plus a second
    // lighter-blue one around the inner element. MUI always puts the border on
    // its wrapper (the notched outline / underline) and never on the element,
    // so clearing it here is what the component already expects.
    //
    // `&&` is load-bearing: `.MuiInputBase-input:hover` and the sheet's
    // `textarea:hover` are both (0,1,1), so a single class would TIE and be
    // decided by injection order. Doubling the class wins outright.
    MuiInputBase: {
      styleOverrides: {
        input: {
          '&&': { border: 'none' },
          '&&:hover, &&:focus, &&:active': { border: 'none' },
        },
      },
    },
    // Ticked checkboxes use blue3, the activity cards' eye-icon blue, like the native ones
    // (formCss) instead of MUI's default #1976D2.
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked, &.MuiCheckbox-indeterminate': {
            color: colors.blue3,
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        // Only outlined inputs that hold a select; text fields keep MUI's border.
        root: {
          '& .MuiSelect-select ~ .MuiOutlinedInput-notchedOutline': {
            borderColor: DROPDOWN_BORDER_COLOR,
          },
          '&:hover:not(.Mui-disabled) .MuiSelect-select ~ .MuiOutlinedInput-notchedOutline': {
            borderColor: DROPDOWN_CHEVRON_COLOR,
          },
        },
      },
    },
  },
});
